import logo from "url:../assets/img/logolandscape.png";

export function Navbar() {
  return `
    <nav class="navbar navbar-expand-lg navbar-dark bg-transparent fixed-top py-2 px-2" style="--bs-bg-opacity: .2;">
      <div class="container">

        <a class="navbar-brand d-flex align-items-center" href="#">
            <img src="${logo}" alt="Logo" height="50" class="me-2">
            <span class="fw-bold"><span style="color:#E50914;">Hunter</span> Cuan</span>
        </a>

        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
        </button>

        <div class="collapse navbar-collapse" id="navbarNav">
          <ul class="navbar-nav ms-auto align-items-lg-center">

            <li class="nav-item">
              <a class="nav-link" href="#">Home</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#layanan">Layanan</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#harga">Harga</a>
            </li>

            <li class="nav-item">
              <a class="nav-link" href="#tentang">Tentang</a>
            </li>

            <li class="nav-item ms-lg-3 mt-3 mt-lg-0">
              <a href="https://wa.me/6283872687465?text=Halo%20saya%20ingin%20konsultasi%20jasa%20Hunter%20Cuan" class="btn btn-danger px-4">
                WhatsApp
              </a>
            </li>

          </ul>
        </div>

      </div>
    </nav>
  `;
}
